// 物业项目信息目录
import request from '@/utils/httpRequest'

export function queryById (id) {
    return request({
        url: '/base/wuyeBaseProject/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/base/wuyeBaseProject/startFlow',
        method: 'post',
        data: params
    })
}